import React from "react";
import "./GitHubFooter.css";

export default function FooterIcon() {
  return (
    <footer className="footer-container">
      <a
        href="https://github.com/NTNUI-Orientering/Hvordan-Vinne-10mila"
        target="_blank"
        rel="noopener noreferrer"
        aria_label="GitHub Repository"
      >
        <img
          src={`${process.env.PUBLIC_URL}/github_icon.png`}
          alt="GitHub"
          className="github-icon"
        />
      </a>
    </footer>
  );
}
